import { render, staticRenderFns } from "./CampaignChannelsSettings.vue?vue&type=template&id=5f0f1b4b&"
import script from "./CampaignChannelsSettings.vue?vue&type=script&lang=js&"
export * from "./CampaignChannelsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports